import { Pagination as MuiPagination } from "@mui/material";
import { Box } from "@mui/system";
import React, { useEffect, useMemo, useState } from "react";
import { PaginationProps } from "./Pagination.types";

function Pagination({ onChange = () => {}, align = "end", total = 0, ...others }: PaginationProps) {
  const pager = useMemo(() => {
    const page = parseInt(others.page) || 1;
    const size = parseInt(others.size) || 10;
    return { size, page };
  }, [others]);

  const count = useMemo(() => Math.ceil(total / pager.size), [total]);

  return (
    <Box sx={{ display: "flex", justifyContent: align }}>
      <MuiPagination count={count} siblingCount={1} boundaryCount={1} size={"large"} onChange={(e, page) => onChange(page)} page={pager.page} />
    </Box>
  );
}

export default Pagination;
